import {createJSONStorage, persist} from "zustand/middleware";
import {type RoleOfUserVO, RoleUserVO, useQueryRoleUser} from "@/service/user.s";
import {create} from "zustand/react";
import isEmpty from "lodash/isEmpty";

enum UserEnum {
    RoleUser = "roleUser",
}

type UserStore = {
    roleUser: RoleOfUserVO;
    actions: {
        setRoleUsers: (roleUsers: RoleOfUserVO) => void;
    };
};

const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            roleUser: {},
            actions: {
                setRoleUsers: (roleUser: RoleOfUserVO) => set({roleUser}),
            },
        }),
        {
            name: "userStore",
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                [UserEnum.RoleUser]: state.roleUser,
            }),
        },
    ),
);

export const useGetRoleUser = () => {
    const {setRoleUsers} = useUserActions();
    const {mutateAsync: queryRoleUsersMutate} = useQueryRoleUser();

    const getRoleUser = async () => {
        const {data} = await queryRoleUsersMutate();
        setRoleUsers(data!);
    };
    return getRoleUser;
};

export const useRoleUsers = (aliases: string[]) => {
    const roleUser = useUserStore.getState().roleUser;
    if (isEmpty(aliases)) {
        return Object.values(roleUser).flat()
    } else {
        let roleUsers: RoleUserVO[] = []
        Object.keys(roleUser).forEach((item) => {
            if (aliases.includes(item)) {
                roleUsers = roleUsers.concat(roleUser[item]);
            }
        })
        return roleUsers
    }
}


export const useUserActions = () => useUserStore((state) => state.actions);
